import { deleteChannel } from '../../services/api/channel.api';
import { DELETE_CHANNEL_REQUEST, DELETE_CHANNEL_SUCCESS, DELETE_CHANNEL_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[DELETE_CHANNEL_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[DELETE_CHANNEL_SUCCESS](state) {
			state.isLoading = false;
		},
		[DELETE_CHANNEL_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async removeChannel({ commit }, id) {
			try {
				commit(DELETE_CHANNEL_REQUEST);
				await deleteChannel(id);
				commit(DELETE_CHANNEL_SUCCESS);
			} catch (error) {
				commit(DELETE_CHANNEL_FAILURE, error);
			}
		},
	},
};